import React from 'react';
import PropTypes from 'prop-types';
import css from './CwPod.scss';
import cx from 'classnames';

const CwPod = (props) => {
  const getTitle = () => {
    if (props.title || props.ghostTitle || props.titleElements) {
      return (
        <div className={css.header}>
          <div className={cx(css.headerText, { [css.ghostTitle]: props.ghostTitle })}>
            {props.ghostTitle ? 'pods are lame' : props.title}
          </div>
          {props.titleElements}
        </div>);
    }

    return null;
  };

  return (
    <div data-cwid={props.cwId} className={cx({ [css.nested]: props.nested })}>
      {getTitle()}
      <div>
        {props.children}
      </div>
    </div>
  );
};

CwPod.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Unique id used to identify pod
   */
  podID: PropTypes.string.isRequired,
  /**
   * Optional text to display in title bar
   */
  title: PropTypes.string,
  /**
   * True to include pod title spacing without any text
   * This is used to align pods when they're next to each other
   */
  ghostTitle: PropTypes.bool,
  /**
   * Array of elements to render next to pod title
   */
  titleElements: PropTypes.arrayOf(PropTypes.element),
  /**
   * Whether the pod is nested within another element, such as a grid, and requires indentation.
   */
  nested: PropTypes.bool,
  /**
   * Pod body content
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
};

export default CwPod;


// WEBPACK FOOTER //
// ./src/components/cwpod/CwPod.jsx